import React from 'react';
import FeatureCard from './FeatureCard';

const Features = ({ features }) => {
  return (
    <>
    {/* Sección de encabezado con imagen de fondo */}
    <section 
      id="why-choose" 
      className="relative py-20 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80")'
      }}
    >
      {/* Overlay oscuro para mejor legibilidad */}
      <div className="absolute inset-0 bg-black bg-opacity-70"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Línea decorativa superior */}
          <div className="w-24 h-1 mx-auto mb-8 bg-blue-500"></div>

          {/* Título limpio y elegante */}
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-8">
            ¿Por qué elegir 
            <span className="text-blue-400 ml-3">Salient</span>?
          </h2>

          {/* Párrafo descriptivo */}
          <p className="max-w-4xl text-xl md:text-2xl mx-auto leading-relaxed text-gray-200">
            Porque no solo vendemos servicios, ofrecemos 
            <span className="font-semibold text-white"> soluciones reales </span>
            que combinan tecnología, estrategia y energía para transformar 
            la forma en que trabajas, vendes o vives.
          </p>

          {/* Elemento decorativo inferior */}
          <div className="flex justify-center mt-12">
            <div className="flex space-x-2">
              <div className="w-3 h-3 rounded-full bg-white"></div>
              <div className="w-3 h-3 rounded-full bg-blue-500"></div>
              <div className="w-3 h-3 rounded-full bg-white"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Sección de características con diseño minimalista */}
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <FeatureCard key={index} feature={feature} index={index} />
          ))}
        </div>
      </div>
    </section>
    </>
  );
};

export default Features;
